import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getOverviewReportStats } from 'api';

// Then, handle actions in your reducers:
const overviewReportStatsSlice = createSlice({
  name: 'overviewReportStats',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    overviewReportStatsFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    overviewReportStatsFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    overviewReportStatsFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    overviewReportStatsResetState: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  overviewReportStatsFetchStart,
  overviewReportStatsFetchSuccess,
  overviewReportStatsFetchFail,
  overviewReportStatsResetState,
} = overviewReportStatsSlice.actions;

// The reducer
export const overviewReportStatsReducer = overviewReportStatsSlice.reducer;

// Asynchronous thunk action
export const overviewReportStatsFetch = (id: string) => (dispatch) => {
  dispatch(overviewReportStatsFetchStart());

  getOverviewReportStats(id)
    .then((overviewReportStats) => {
      dispatch(overviewReportStatsFetchSuccess(overviewReportStats.data));
    })
    .catch((error) => {
      dispatch(overviewReportStatsFetchFail(error));
    });
};
